import { createContext } from 'react'

const EntityEditorInfoContext = createContext({
    insideEntityEditor: false,
    renderTopNotifications: () => null,
    renderSectionHint: (sectionName) => null,
})

export default EntityEditorInfoContext
